const NAME = 'workflows';

const ASSET = {
  VEHICLE: 1,
};

const ASSET_NAME = {
  [ASSET.VEHICLE]: 'Vehicle',
};

const VEHICLE_TYPES = {
  CAR: 1,
  MOTORCYCLE: 2,
  TRUCK: 3,
  TRAILER: 4,
  BUS: 7
};

const VEHICLE_TYPE_NAME = {
  [VEHICLE_TYPES.CAR]: 'Car',
  [VEHICLE_TYPES.MOTORCYCLE]: 'Motorcycle',
  [VEHICLE_TYPES.TRUCK]: 'Truck',
  [VEHICLE_TYPES.TRAILER]: 'Trailer',
  [VEHICLE_TYPES.BUS]: 'Bus'
};

const DAMAGE_MARKING_LEVEL = {
  BLOCKER: 0,
  WARNING: 1,
  HIDDEN: 2
};

const DAMAGE_MARKING_TYPE = {
  OFF: 0,
  MANUAL: 1,
  AI: 2
};

const DAMAGE_MARKING_TYPE_NAME = {
  [DAMAGE_MARKING_TYPE.OFF]: 'Off',
  [DAMAGE_MARKING_TYPE.MANUAL]: 'Manual',
  [DAMAGE_MARKING_TYPE.AI]: 'AI'
};

const DAMAGE_TYPE_SELECTION_TYPE = {
  OFF: 0,
  MANUAL: 1,
  AI: 2
};

const DAMAGE_TYPE_SELECTION_TYPE_NAME = {
  [DAMAGE_TYPE_SELECTION_TYPE.OFF]: 'Off',
  [DAMAGE_TYPE_SELECTION_TYPE.MANUAL]: 'Manual',
  [DAMAGE_TYPE_SELECTION_TYPE.AI]: 'AI'
};

export default {
  ASSET,
  ASSET_NAME,
  NAME,
  VEHICLE_TYPES,
  VEHICLE_TYPE_NAME,
  DAMAGE_MARKING_LEVEL,
  DAMAGE_MARKING_TYPE,
  DAMAGE_MARKING_TYPE_NAME,
  DAMAGE_TYPE_SELECTION_TYPE,
  DAMAGE_TYPE_SELECTION_TYPE_NAME
};
